<template>
  <div class="main-content">
    <div class="section__content section__content--p30 p-b-30">
      <div class="container-fluid">
        <div class="overview-wrap m-b-35">
          <h2 class="title-1">
            <i class="fab fa-keycdn p-r-10" style="padding-left: 7px;"></i>
            {{ text('distrib_header') }} ({{ distributions.length }})
          </h2>
          <v-btn color="success" @click="newDistribution()">
            <i class="zmdi zmdi-plus p-r-10"></i>{{ text('new_distrib_btn') }}
          </v-btn>
        </div>
        <v-card class="p-b-10 p-t-10 p-l-30 p-r-30 m-b-30">
          <div class="el-loading-mask" v-if="loading">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <div class="row">
            <div class="table-responsive table-hover live-jobs">
              <table class="align-middle table">
                <thead>
                <tr>
                  <th>{{ text('name') }}</th>
                  <th>{{ text('created') }}</th>
                  <th>CDN</th>
                  <th>{{ text('channels') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="!loading && !distributions.length">
                  <td colspan="7" class="text-center">
                    <div class="m-b-15 m-t-15">
                      {{ text('no_distrib_text') }}
                    </div>
                  </td>
                </tr>
                <tr v-for="distribution of distributions" :key="distribution.id">
                  <td @click="showDetail(distribution)">
                    {{ distribution.name }}
                  </td>
                  <td @click="showDetail(distribution)">
                    {{ formatCreateTime(distribution.createTime) }}
                  </td>
                  <td @click="showDetail(distribution)">
                    <span v-if="distribution.cdn.id && !distribution.cdn.disabled">
                        <i class="fa fa-exclamation-circle job-status--failed"
                           v-if="distribution.cdn.state === 'error'">
                        </i>
                        <i class="fa fa-check-circle job-status--finished"
                           v-else-if="distribution.cdn.state === 'ok'">
                        </i>
                        <i class="fa fa-clock job-status--paused"
                           v-else>
                        </i>
                      </span>
                    <span v-else-if="distribution.cdn.id">
                        <i class="fa fa-stop-circle job-status--failed"></i>
                    </span>
                    {{ distribution.cdn.name }}
                  </td>
                  <td @click="showDetail(distribution)">
                    <span class="text-uppercase blocked-text"
                          v-for="(channel, channelIndex) of distribution.channels.slice(0, 3)"
                          :key="channel.id"
                          :class="{
                          'm-r-5': distribution.channels.length > 0 && channelIndex < distribution.channels.length-1,
                          }">
                      {{ channel.name }}
                    </span>
                    <span class="text-uppercase blocked-text m-l-5" v-if="distribution.channels.length > 3">
                      +{{ distribution.channels.length - 3 }}
                    </span>
                  </td>
                  <td class="text-right" style="width: 80px;">
                    <v-menu bottom left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-tile @click="editCD(distribution)" v-ripple>
                          <v-list-tile-action>
                            <v-icon>edit</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ text('edit_btn') }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="openDeleteDialog(distribution)" color="red" v-ripple>
                          <v-list-tile-action>
                            <v-icon color="red">delete</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ text('remove_btn') }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card>

        <!-- Remove Dialog -->
        <v-dialog v-model="removeDialog" max-width="500" persistent>
          <v-card>
            <v-card-title class="headline">
              Delete distribution?
            </v-card-title>
            <v-card-text>
              <div class="row p-b-20">
                <div class="col-md-12">
                  Are you sure you want to delete the distribution "{{ deleted.name }}"?
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed small text
                     @click="removeDialog = false">{{ text('no_btn') }}</v-btn>
              <v-btn depressed small color="error"
                     @click="deleteCD()">{{ text('yes_btn') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { processChannelDistribution } from '@/store/converters';

export default {
  created() {
    this.loadData();
  },
  data() {
    return {
      removeDialog: false,
      deleted: {},
      distributions: [],
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    loadData() {
      this.$store.commit('setPageLoader');
      this.$store.dispatch('channelDistribs/getChannelDistribs')
        .then((result) => {
          this.distributions = result.map(cd => processChannelDistribution(cd));

/*          const uniqueChannels = {};
          for (let i = 0; i < this.distributions.length; i += 1) {
            for (let j = 0; j < this.distributions[i].channels.length; j += 1) {
              if (!uniqueChannels.hasOwnProperty(this.distributions[i].channels[j].name)) {
                uniqueChannels[this.distributions[i].channels[j].name] = [];
              }
              uniqueChannels[this.distributions[i].channels[j].name].push(this.distributions[i].name);
            }
          }*/
        })
        .catch((errorMsg) => {
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 10000,
          });
        })
        .finally(() => this.$store.commit('resolvePageLoader'));
    },
    formatCreateTime(createTime) {
      return moment(createTime).format('DD/MM/YYYY');
    },
    showDetail(distribution) {
      this.$router.push({
        name: 'DistributionDetailPage',
        params: {
          id: distribution.id,
        },
      });
    },
    editCD(cd) {
      this.$router.push({
        name: 'DistributionEditPage',
        params: {
          id: cd.id,
        },
      });
    },
    openDeleteDialog(cd) {
      this.deleted = Vue.util.extend({}, cd);
      this.removeDialog = true;
    },
    deleteCD() {
      if (!this.deleted.id) return;
      this.$store.dispatch('channelDistribs/removeChannelDistrib', this.deleted.id)
        .then(() => {
          this.$toasted.success('The distribution has been successfully removed', {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 5000,
          });
          this.loadData();
          this.deleted = {};
          this.removeDialog = false;
        })
        .catch((errorMsg) => {
          this.deleted = {};
          this.removeDialog = false;
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 7000,
          });
        });
    },
    newDistribution() {
      this.$router.push({
        name: 'DistributionNewPage',
      });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
